<template>
  <div class="metrics-conversations" :key="key">
    <v-card outlined rounded="lg" class="pa-6 pb-8">
      <div class="f18 font-weight-bold">Total conversations</div>
      <div class="d-flex align-center">
        <div class="font-weight-bold f36">{{ counters.total }}</div>
        <div class="status ml-4 success lighten-5 success--text" v-if="counters.new">
          <v-icon color="success" class="mr-1">mdi-arrow-top-right</v-icon> {{ counters.new }} conversations today
        </div>
      </div>
    </v-card>
    <v-card outlined rounded="lg" class="pa-4 mt-4 growth">
      <div class="f18 font-weight-bold mb-3">Conversations growth</div>
      <v-chartist type="Line" :data="{ labels: growth.labels, series: [growth.series] }" :options="chartOptions"></v-chartist>
    </v-card>
    <v-card outlined rounded="lg" class="pa-4 mt-4 add">
      <div class="f18 font-weight-bold mb-3">Conversation started</div>
      <v-chartist type="Bar" :data="add" :options="chartOptions"></v-chartist>
    </v-card>
  </div>
</template>

<script>
import VueChartist from 'v-chartist';

export default {
  components: {
    'v-chartist': VueChartist,
  },
  props: {
    period: String,
    date: Object,
  },
  data() {
    return {
      key: 1,
      chartOptions: {
        height: '280px',
        fullWidth: true,
        distributeSeries: true,
        lineSmooth: false,
        showPoint: false,
        chartPadding: {
          right: 30,
        },
        axisX: {
          showGrid: false,
        },
      },
      growth: { series: [] },
      add: {},
      typeList: ['total', 'new'],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch('getMetricPageCounter', { page: 'conversations' });
      for (let i = 0; i < this.typeList.length; i++) {
        this.$store
          .dispatch('getMetricPageStatistics', {
            page: 'conversations',
            period: this.period,
            from: this.date.start,
            to: this.date.end,
            type: this.typeList[i],
          })
          .then((res) => {
            if (i == 0) {
              this.growth = res.data;
            } else if (i == 1) {
              this.add = res.data;
            }
          });
      }
    },
  },
  computed: {
    counters() {
      return this.$store.getters.metricPageCounter;
    },
  },
};
</script>

<style lang="scss">
.metrics-conversations {
  .status {
    display: flex;
    align-items: center;
    font-weight: 500;
    padding: 5px 16px 6px 10px;
    border-radius: 16px;
  }
  .add,
  .growth {
    .ct-bar,
    .ct-point,
    .ct-line {
      stroke: var(--v-primary-base);
    }
  }
  .add {
    .ct-bar {
      stroke-width: 20px;
    }
  }
}
</style>
